import { RoutalPalette } from '@nx-smartmonkey/ui';
import styled from 'styled-components';

interface SideBarMenuItemProps {
  selected?: boolean;
  isHover?: boolean;
}
const SideBarMenuItem = styled.div<SideBarMenuItemProps>`
  width: 35px;
  height: 35px;

  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.selected ? RoutalPalette.primary20n : props.isHover ? RoutalPalette.neutral00 : `transparent`};
`;

export default SideBarMenuItem;
